import {Injectable} from '@angular/core';
import {Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {CanActivate} from '@angular/router';
import {AuthService} from './auth.service';

@Injectable()
export class AdminGuard implements CanActivate {

    constructor(private auth: AuthService, private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.auth.authenticated() && this.auth.userIsAdmin()) {
            if(!this.auth.locked()){
                return true; /** SUCCESS */
            }else{
                this.router.navigate(['session/lockscreen']);
            }
        } else {
            this.router.navigate(['/']);
        }
        return false;
    }
}


// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/admin.guard.ts